"use client";
import { List, Text, Title } from "@mantine/core";
import classes from "../privacy/legal.module.css";

export default function Terms() {
  return (
    <>
      <Title order={1} className={classes.legalTitle}>
        Terms and Conditions
      </Title>
      <Text className={classes.legalText}>Last updated August 04, 2022</Text>
      <Text className={classes.legalText}>
        This website is operated by One Step Education Ltd CRN 13431410, who
        trade as Tiber Tutor (“Tiber Tutor”, “we”, “us”, “our”) under the domain
        name tibertutor.com (“the website”).
      </Text>
      <Text className={classes.legalText}>
        We offer you the service of Tiber Tutor on the condition that you agree
        to the following terms:
      </Text>
      <Title order={2} className={classes.legalHeader}>
        Intellectual Property Rights
      </Title>
      <Text className={classes.legalText}>
        Copyright protects the material contained on the website. You may use
        the website for personal and non¬commercial purposes only. You
        acknowledge that the Tiber Tutor website, special technology used in
        connection with the website, Tiber Tutor&apos;s services, all software,
        material, information, communications, text, graphics, links, electronic
        art, animations, audio, video, photos, and other data available within
        the website (“Tiber Tutor content”) are provided by Tiber Tutor and are
        the copyrighted works of Tiber Tutor. You may not copy, reproduce,
        publish, distribute, modify, create derivative works of, rent, lease,
        sell, transfer, display, transmit, compile or collect in a database, or
        in any manner commercially exploit any part of the Tiber Tutor content
        or our services in whole or in part unless expressly authorized by Tiber
        Tutor.
      </Text>
      <Text className={classes.legalText}>
        You may not store any significant portion of any Tiber Tutor content or
        Tiber Tutor services or materials in any form. You acknowledge that
        Tiber Tutor remain the owners of the Tiber Tutor content and that you do
        not acquire any intellectual property rights in the Tiber Tutor content
        through any means.
      </Text>
      <Text className={classes.legalText}>
        All material on the Tiber Tutor website has been developed independently
        by Tiber Tutor and is therefore not associated nor endorsed in any way
        from the International Baccalaureate Organisation.
      </Text>
      <Title order={2} className={classes.legalHeader}>
        Representation of Professional Advice
      </Title>
      <Text className={classes.legalText}>
        The material provided on the website is not intended as professional
        advice, provides general information only and must not be relied upon as
        a professional recommendation. Prior to taking any course of action in
        connection with the website, including entering any transaction, you
        should seek independent advice and make necessary enquiries tailored to
        your specific circumstances and objectives.
      </Text>
      <Title order={2} className={classes.legalHeader}>
        Usefulness and Accuracy of Information
      </Title>
      <Text className={classes.legalText}>
        All material and information on the website is believed to be accurate
        and current as at the date of publication and is provided in good faith.
        However, Tiber Tutor provides no warranty or guarantee that any material
        or information on the website or linked websites is accurate or
        complete.
      </Text>
      <Text className={classes.legalText}>
        Tiber Tutor will not be liable for any damages whatsoever whether in an
        action in contract, negligence or other tort, arising out of or in
        connection with access to the website or the information and material
        contained in it. All warranties of any kind are excluded to the maximum
        extent permitted by law.
      </Text>
      <Text className={classes.legalText}>
        Tiber Tutor makes no guarantee as to the usefulness of the information
        and material on the website, nor any of the products and services
        promoted in any way. In particular, Tiber Tutor makes no guarantee as to
        the appropriateness of the subscription selected by you and no guarantee
        as to the quality or likelihood of results which may be gained through
        access to the material on the website and any resulting training
        undertaken.
      </Text>
      <Title order={2} className={classes.legalHeader}>
        Access
      </Title>
      <Text className={classes.legalText}>
        You understand and agree that Tiber Tutor has absolute discretion to
        prevent or restrict your access to the website for any technical,
        security and or any other reasons at any point in time without warning.
        Tiber Tutor will inform you when practicable of any restrictions imposed
        on your access to the website.
      </Text>
      <Title order={2} className={classes.legalHeader}>
        Variation of These Terms
      </Title>
      <Text className={classes.legalText}>
        Tiber Tutor has the right to alter these Terms at any time. If Tiber
        Tutor does so, notice will be provided by publishing the altered Terms
        on the website. You accept that by doing this, Tiber Tutor has provided
        you with sufficient notice of any alterations made.
      </Text>
      <Title order={2} className={classes.legalHeader}>
        No Warranties or Representations
      </Title>
      <Text className={classes.legalText}>
        Tiber Tutor does not exclude any rights or remedies available to you
        under the Trade Practices Act (Cth) or equivalent State legislation that
        cannot be excluded or restricted. To the extent permissible by law,
        Tiber Tutor makes no warranty or representation (express or implied)
        regarding the quality, accuracy, reliability, currency, performance,
        completeness or fitness for purpose of any part of the website or any of
        the Tiber Tutor content.
      </Text>
      <Text className={classes.legalText}>
        Tiber Tutor does not represent or warrant (expressly or impliedly) that
        the website or any of the Tiber Tutor content, or the facilities that
        make the website functional, will not cause damage, or are free from any
        computer virus or any other defects or errors.
      </Text>
      <Text className={classes.legalText}>
        To the maximum extent permitted by law, Tiber Tutor is not liable
        (whether in contract, negligence or otherwise) for any loss or damage
        arising from the use of the website or any of the Tiber Tutor content.
      </Text>
      <Text className={classes.legalText}>
        To the maximum extent permissible by law, Tiber Tutor&apos;s liability
        for breach of any implied warranty or conditions that cannot be excluded
        is restricted, at Tiber Tutor&apos;s option, to:
        <List
          className={classes.legalList}
          styles={{ itemWrapper: { maxWidth: "calc(100% - 0.75em)" } }}
        >
          <List.Item>
            the re-supply of the relevant goods or services;
          </List.Item>
          <List.Item>
            or the cost of the re-supply of the relevant goods or services;
          </List.Item>
          <List.Item>
            or any amount paid by you to Tiber Tutor in respect of the relevant
            goods or services.
          </List.Item>
        </List>
      </Text>
      <Text className={classes.legalText}>
        You agree that in no circumstances will Tiber Tutor be liable for any
        indirect, incidental, special and/or consequential losses or damages of
        whatever nature arising out of your use of the website or of any of the
        Tiber Tutor content (including, but not limited to, losses or damages
        arising out of, or attributable to, an act or omission by Tiber Tutor).
      </Text>
      <Title order={2} className={classes.legalHeader}>
        Prices and Payments
      </Title>
      <Text className={classes.legalText}>
        All prices quoted on the website are quoted in US Dollars (“USD”), Great
        British Pounds (&quot;GBP&quot;), and Euros (&quot;EUR&quot;). A payment
        to be made to Tiber Tutor must always be done so in accordance with
        Tiber Tutor&apos;s Terms of Purchase Refund Policy below. Payments in
        currencies other than USD, GBP, or EUR will not be accepted and any
        attempted registration will be incomplete until correct payment is made.
        All prices quoted on the website are subject to change without prior
        notice and as such you should confirm the price of a product or service
        before placing an order.
      </Text>
      <Title order={2} className={classes.legalHeader}>
        Terms of Purchase and Refund Policy
      </Title>
      <Text className={classes.legalText}>
        Before you make a purchase on Tiber Tutor&apos;s website, you agree that
        you have read, understood and agree to Tiber Tutor&apos;s Terms of
        Purchase and Refund Policy below.
      </Text>
      <Title order={3} className={classes.legalSubHeader}>
        Terms of Purchase:
      </Title>
      <List
        className={classes.legalList}
        styles={{ itemWrapper: { maxWidth: "calc(100% - 0.75em)" } }}
      >
        <List.Item>
          Tiber Tutor will charge your credit/debit card with the subscription
          fee for the courses that are described on the website before you enter
          your credit/debit card details.
        </List.Item>
        <List.Item>
          Tiber Tutor accepts Visa, MasterCard and American Express cards.
        </List.Item>
        <List.Item>
          Tiber Tutor does not accept Money Orders, Cash or Cheque payments.
        </List.Item>
        <List.Item>
          Tiber Tutor Registered Users can review their payment history and the
          courses they have paid for in the “Profile” section of the website.
        </List.Item>
        <List.Item>
          Invoices for the payment of your subscription are send via email.
        </List.Item>
        <List.Item>
          Tax invoices for the payment of your subscription fees can be sent to
          you on request.
        </List.Item>
      </List>
      <Title order={3} className={classes.legalSubHeader} id="refund">
        Refund Policy:
      </Title>
      <List
        className={classes.legalList}
        styles={{ itemWrapper: { maxWidth: "calc(100% - 0.75em)" } }}
      >
        <List.Item>
          Tiber Tutor offers a 7-day free trial prior to the first purchase for
          each customer, and so does not offer refunds on first payments.
        </List.Item>
        <List.Item>
          For subsequent purchases, customers have the right to request a refund
          within 3-days of the payment, with their case being reviewed on an
          individual basis.
        </List.Item>
        <List.Item>
          It remains at Tiber Tutor&apos;s sole discretion to approve the
          request for any refund.
        </List.Item>
        <List.Item>
          When receiving a refund, the total sum refunded will be less any costs
          of the initial transaction.
        </List.Item>
        <List.Item>
          In the event the IB exams are cancelled for any reason, Tiber Tutor
          will not adjust their refund policy.
        </List.Item>
        <List.Item>
          If you have any purchase queries, please contact: info@tibertutor.com
        </List.Item>
      </List>
      <Title order={2} className={classes.legalHeader}>
        Links to Third Party Websites
      </Title>
      <Text className={classes.legalText}>
        The website contains viewable and downloadable materials through links
        to external websites. These links are included solely for your
        convenience and do not constitute endorsement, sponsorship or approval
        by Tiber Tutor of the content, policies or practices of those external
        websites. Tiber Tutor is not responsible for, and has no control over,
        the content on external sites.
      </Text>
      <Text className={classes.legalText}>
        You understand that Tiber Tutor cannot and does not guarantee, warrant
        or represent that files from such sources will be free of infection or
        viruses, worms, Trojan horses or other code or defects that manifest
        contaminating or destructive properties. As such you agree that by
        accessing any third party linked website you do so at entirely at your
        own risk.
      </Text>
      <Text className={classes.legalText}>
        Tiber Tutor will not be responsible or liable, directly or indirectly,
        for any damage or loss caused or alleged to be caused by or in
        connection with, use or reliance on any goods or services available on
        or through any external website.
      </Text>
      <Title order={2} className={classes.legalHeader}>
        Security and Safety
      </Title>
      <Text className={classes.legalText}>
        When using the World Wide Web, the Internet or third party networks or
        facilities, you are using networks, facilities and services that are
        beyond the control of Tiber Tutor. You assume all risk and liability of
        your use of the World Wide Web, the Internet or any such third party
        networks, including any access to the website via such media.
      </Text>
      <Title order={2} className={classes.legalHeader}>
        Severability
      </Title>
      <Text className={classes.legalText}>
        If any part of these Terms is held invalid, illegal or unenforceable,
        that part shall be severed and the remainder will continue to be valid
        and enforceable.
      </Text>
      <Title order={2} className={classes.legalHeader}>
        General
      </Title>
      <Text className={classes.legalText}>
        The use of the website is governed by, construed and enforced in
        accordance with the laws of England and Wales, and you irrevocably
        submit to the non¬exclusive jurisdiction of the courts of England and
        Wales, and their respective courts of appeal in that regard.
      </Text>
      <Title order={2} className={classes.legalHeader}>
        Reservation of Rights
      </Title>
      <Text className={classes.legalText}>
        Any rights not expressly granted to you herein are reserved by Tiber
        Tutor. For the purposes of this agreement the words “Tiber Tutor”, “We”,
        “Our” and “Us” refer to One Step Education Ltd and “website” to
        materials delivered on tibertutor.com and other co branded versions of
        the site.
      </Text>
      <Title order={2} className={classes.legalHeader}>
        Conduct Policy
      </Title>
      <Text className={classes.legalText}>
        By using this website, you agree to Tiber Tutor&apos;s Conduct Policy
        below. You must not:
      </Text>
      <List
        className={classes.legalList}
        styles={{ itemWrapper: { maxWidth: "calc(100% - 0.75em)" } }}
        listStyleType="lower-alpha"
      >
        <List.Item>
          use the website in breach of any applicable laws or regulations;
        </List.Item>
        <List.Item>
          use the website (or material obtained from the website):
          <List
            className={classes.legalList}
            styles={{ itemWrapper: { maxWidth: "calc(100% - 0.75em)" } }}
          >
            <List.Item>
              to harm, abuse, harass, stalk, threaten or otherwise offend
              others;
            </List.Item>
            <List.Item>to carry out any unlawful purpose;</List.Item>
            <List.Item>
              to transmit (or authorize the transmission of) “junk mail,” “chain
              letters,” unsolicited emails, instant messaging, “spimming,” or
              “spamming”;
            </List.Item>
            <List.Item>to impersonate any person or entity;</List.Item>
            <List.Item>
              or to solicit money, passwords or personal information from any
              person;
            </List.Item>
          </List>
        </List.Item>
        <List.Item>
          use the website to attempt or succeed in uploading, posting,
          transmitting, or otherwise making available any material that:
          <List
            className={classes.legalList}
            styles={{ itemWrapper: { maxWidth: "calc(100% - 0.75em)" } }}
          >
            <List.Item>
              is not your original work, or which in any way expects or succeeds
              in violating or infringing the intellectual property or other
              rights of another person;
            </List.Item>
            <List.Item>
              is, or could reasonably be expected to be, defamatory, obscene,
              offensive, threatening, abusive, pornographic, vulgar, profane,
              indecent or otherwise unlawful, including material that racially
              or religiously vilifies, incites violence or hatred, or is likely
              to offend, insult or humiliate others based on race, religion,
              ethnicity, gender, age, sexual orientation or any physical or
              mental disability;
            </List.Item>
            <List.Item>
              contains, promotes, or provides information about unlawful
              activities or conduct;
            </List.Item>
            <List.Item>
              contains nudity, excessive violence, or sexual acts or references;
            </List.Item>
            <List.Item>
              includes an image or personal information of another person or
              persons unless you have their consent;
            </List.Item>
            <List.Item>
              poses or creates a privacy or security risk to any person;
            </List.Item>
            <List.Item>exploits another person in any manner;</List.Item>
            <List.Item>
              contains large amounts of untargeted, unwanted or repetitive
              content;
            </List.Item>
            <List.Item>
              advertises, promotes or solicits any goods or services or
              commercial activities (except where expressly permitted or
              authorized by us);
            </List.Item>
            <List.Item>
              you know or suspect (or ought reasonably to have known or
              suspected) to be false, misleading or deceptive;
            </List.Item>
            <List.Item>
              contains financial, legal, medical or other professional advice;
            </List.Item>
            <List.Item>
              contains restricted or password only access pages, or hidden
              content;
            </List.Item>
            <List.Item>
              or contains viruses, or other computer codes, files or programs
              designed to interrupt, limit or destroy the functionality of other
              computer software or hardware;
            </List.Item>
          </List>
        </List.Item>
        <List.Item>
          interfere with, disrupt, or create an undue burden on Tiber Tutor;
        </List.Item>
        <List.Item>
          use any robot, spider, or other device or process to retrieve, index,
          or in any way reproduce, modify or circumvent the navigational
          structure, security or presentation of the website;
        </List.Item>
        <List.Item>
          use the website with the assistance of any automated scripting tool or
          software;
        </List.Item>
        <List.Item>
          frame or mirror any part of the website without our prior written
          authorization;
        </List.Item>
        <List.Item>
          use code or other devices containing any reference to the website to
          direct other persons to any other web page;
        </List.Item>
        <List.Item>
          except to the extent permitted by law, modify, adapt, sublicense,
          translate, sell, reverse engineer, decipher, decompile or otherwise
          disassemble any portion of the website or cause any other person to do
          so;
        </List.Item>
        <List.Item>
          or delete, alter, or copy any attributions or legal or proprietary
          notices on the website.
        </List.Item>
      </List>
    </>
  );
}
